var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.rooms),function(room){return _c('RoomListItem',{key:room.id,attrs:{"room":room}})}),_vm._v(" "),_c('div',[_c('router-link',{attrs:{"to":{ name: 'RoomCreateView' }}},[_vm._v("Luo huone")])],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c16cc5b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoomListView.vue
// module id = null
// module chunks = 